<template>
    <div>
        <div class="instruction">
            {{ $t('Enter the SMS code to validate the phone number') }}
        </div>
        <div class="important-box">
            <div class="important-box__left">
                <i class="icon icon--md icon-help_circle"/>
                <div>{{ $t('current number') | capitalize }}</div>
            </div>
            <div class="important-box__right red">{{ phone }}</div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Intro',
        props: {
            phone: {
                type: String,
                required: true
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/smsValidation/components/Intro.vue